<template>
  <section :class="$style.section">
    <header :class="[$style.section__header, $style.header]">
      <SectionTitle :class="$style.header__title">やることリスト</SectionTitle>
    </header>
    <section :class="[$style.section__contents, $style.contents]">
      <FadeTransition>
        <LoadingIndicator v-if="!planner" />
        <TodoList v-else :viewer="viewer" />
      </FadeTransition>
    </section>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import SectionTitle from '@/components/atoms/SectionTitle.vue'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'
import TodoList from '@/components/organisms/TodoList/TodoList.vue'
import type { Planner } from '@/types/app'
import type { DashboardPageTodoListSectionViewerFragment } from './DashboardPageTodoListSection.generated'
import { useDashboardPageQuery } from './DashboardPage.generated.ts'
import { parsePlannerProfileResponseToPlanner } from '@/apis/repositories/parsers/planner.ts'

defineProps<{
  viewer: DashboardPageTodoListSectionViewerFragment
}>()

const pageQuery = useDashboardPageQuery()

const planner = computed<Planner | undefined>(() => {
  const data = pageQuery.result?.value?.planner
  const allSpecialty = pageQuery.result?.value?.specialties || []
  if (data) {
    return parsePlannerProfileResponseToPlanner(
      {
        ...data,
        id: parseInt(data.id),
        corporationId: parseInt(data.corporationId),
        branchIds: data.branchIds.map(id => parseInt(id)),
        specialties: data.specialties.map(specialty => specialty.name),
      },
      allSpecialty.map(specialty => ({
        ...specialty,
        id: parseInt(specialty.id),
      }))
    )
  }
  return undefined
})
</script>

<style lang="scss" module>
.header {
  display: flex;

  &__title {
    flex-grow: 1;
  }
}

.section {
  &__title {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }

  &__contents {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.contents {
  display: flex;
  overflow: hidden;
  min-height: 88px;
  align-items: center;
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;
  box-shadow: $shadow-20;

  &__message {
    &--empty {
      color: $color-text-and-object-low-emphasis;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
